module.exports = __webpack_public_path__ + "static/desktop/img/production-duration.4e4d2fbf.png";